var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{attrs:{"id":_vm.poll.uid,"type":"number","value":_vm.results[_vm.questionnaireUid].answers[_vm.poll.uid].answer[0]}})
}
var staticRenderFns = []

export { render, staticRenderFns }